import React, { Component } from 'react';
import "../../css/admin/ModalSolicitudes.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowClose, faTimesCircle, faCheckCircle,faToggleOff } from '@fortawesome/free-solid-svg-icons';
import logo from "../../assets/logo_espol_interno.svg";
import Face from '@material-ui/icons/Face'
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { memo } from 'react';

export class ModalSolicitudes extends Component {



    render() {
        return (
            <div className="modalSolicitudes-background">
                <div className="modalSolicitudes-container">
                    <div className="modalSolicitudes-header1">
                        <img className='modalSolicitudes-logo' src={logo} alt="Logo espol" ></img>
                        <button className="modalSolicitudes-close" onClick={this.props.cerrarModal} >
                            <FontAwesomeIcon icon={faWindowClose}></FontAwesomeIcon>
                        </button>
                        <p className="modalSolicitudes-tituloHeader">{this.props.tituloHeader}</p>
                    </div>
                    <div className="modalSolicitudes-body">
                        {this.props.children}
                    </div>
                    <div className="modalSolicitudes-container-btn">
                        
                        <button
                            className={(this.props.estado === "No Revisado" || this.props.estado === "No Revisado CC") ? "modalSolicitudes1-botones" : "modalSolicitudes1-botones-disabled"}
                            onClick={this.props.submit}
                            disabled={(this.props.estado === "No Revisado" || this.props.estado === "No Revisado CC") ? false : true}
                        >
                            <FontAwesomeIcon icon={faCheckCircle} className='modalSolicitudes-icono-bnt'></FontAwesomeIcon>
                            {this.props.txtBtnSubmit}
                        </button>

                        <button
                            className={(this.props.estado === "No Revisado" || this.props.estado === "No Revisado CC" || (this.props.estado === "Rechazado CC" && !this.props.motivo.includes("ya aceptado"))  ) ? "modalSolicitudes1-botones" : "modalSolicitudes1-botones-disabled"}
                            onClick={this.props.cancel}
                            disabled={(this.props.estado === "No Revisado" || this.props.estado === "No Revisado CC" || (this.props.estado === "Rechazado CC" && !this.props.motivo.includes("ya aceptado"))) ? false : true}
                        >
                            <FontAwesomeIcon icon={faTimesCircle} className='modalSolicitudes-icono-bnt'></FontAwesomeIcon>
                            {this.props.txtBtnCancel}
                        </button>
                        {this.props.estado==="Rechazado CC" &&
                                <button
                                    className={!this.props.motivo.includes("ya aceptado")  ? "modalSolicitudes1-botones" : "modalSolicitudes1-botones-disabled"}
                                    onClick={this.props.enable}
                                    disabled={this.props.motivo.includes("ya aceptado")  ? true : false}
                                >
                                    <FontAwesomeIcon icon={faToggleOff} className='modalSolicitudes-icono-bnt'></FontAwesomeIcon>
                                    {this.props.txtBtnEnable}
                                </button>
                        }


                    </div>
                </div>
            </div>
        )
    }
}

export default memo(ModalSolicitudes);
